import { useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

import { useNavigateToOrg } from "@/hooks/use-navigate-to-org";
import { useAuthStore } from "@/stores/auth.store";

export function NotFoundPage() {
  const { loggedIn, loading, curUser } = useAuthStore();

  const navigate = useNavigate();
  const { navigateToOrg } = useNavigateToOrg();

  useEffect(() => {
    if (loading) return;
    if (loggedIn && curUser.fbUser?.uid) navigateToOrg(curUser.fbUser.uid);
    else navigate({ to: "/" });
  }, [loading, loggedIn, navigate]);

  return (
    <div className="flex items-center justify-center h-screen w-screen bg-background-primary">
      <div className="text-text-secondary text-lg">Đang tải...</div>
    </div>
  );
}
